import { PropertyType } from "../enums/PropertyType";
import { DEFAULT_PROPERTY_IMAGE } from "../constants/constants";

export function getDefaultValueForType(type: PropertyType) {
  switch (type) {
    case PropertyType.Integer:
      return 0;
    case PropertyType.String:
      return "Пусто";
    case PropertyType.Image:
      return DEFAULT_PROPERTY_IMAGE;
    case PropertyType.Date:
      return "01.01.2000";
    default:
      return 0;
  }
}
